const exList = [

    // =========================================================
    // CITYNET
    // =========================================================
    {
        date: "Present",

        company: "Citynet",

        position: "Product Design Lead",

        location: "On-site",

        description:
            "Redesigning the core foundation of Citynet's travel-tech ecosystem, including B2B travel sales products, admin and management systems, reporting tools, and internal products. I also created the design system and shared product structure to keep experiences consistent across the ecosystem.",

        skills: [
            "Product Design",
            "B2B",
            "Travel Tech",
            "Design System",
            "Admin Systems",
            "Reporting",
            "Internal Tools"
        ]
    },


    // =========================================================
    // TIPAX
    // =========================================================
    {
        date: "1 Year",

        company: "Tosan Techno / Tipax",

        position: "Product Designer",

        location: "Remote",

        description:
            "Designed a complex internal logistics product for Tipax, focusing on operational workflows, information hierarchy, reusable interaction patterns, and making dense logistics processes easier to understand and manage.",

        skills: [
            "Product Design",
            "Logistics",
            "Internal Tools",
            "Operational UX",
            "Complex Systems",
            "UX Design"
        ]
    },


    // =========================================================
    // 3 CLICK
    // =========================================================
    {
        date: "1.5 Years",

        company: "3 Click Group",

        position: "Product Designer",

        location: "Tehran, Iran",

        description:
            "Worked across the redesign of the travel website, booking experiences, CMS, booking panel, and design system. The goal was to create a more consistent product ecosystem while improving both customer-facing and internal experiences.",

        skills: [
            "Product Design",
            "Travel",
            "Booking",
            "CMS",
            "Design System",
            "UX/UI"
        ]
    },


    // =========================================================
    // TOPTOURS
    // =========================================================
    {
        date: "1.3 Years",

        company: "Toptours",

        position: "Product Designer",

        location: "Tehran, Iran",

        description:
            "Designed B2B travel products for ticket sales and daily agency operations, including booking, cancellation, tracking, and operational workflows. I also worked on white-label products and a shared design system.",

        skills: [
            "Product Design",
            "B2B",
            "Travel Tech",
            "Booking Systems",
            "White-label",
            "Design System"
        ]
    },


    // =========================================================
    // CHATR PASARGAD
    // =========================================================
    {
        date: "1 Year",

        company: "Chatr Pasargad",

        position: "Product Designer",

        location: "Remote",

        description:
            "Designed a mobile product for insurance agents, focusing on making insurance-related workflows clearer, more accessible, and easier to manage through a mobile experience.",

        skills: [
            "Product Design",
            "Mobile App",
            "Insurance",
            "UX Design",
            "UI Design"
        ]
    },


    // =========================================================
    // FREELANCE
    // =========================================================
    {
        date: "2 Years",

        company: "Freelance",

        position: "UI/UX & Product Designer",

        location: "Remote",

        description:
            "Worked on web and mobile product design projects, collaborating with different clients to turn product requirements and ideas into clear, usable digital experiences.",

        skills: [
            "Product Design",
            "UI/UX",
            "Web Design",
            "Mobile Design",
            "Prototyping"
        ]
    }

];


export default exList;